export const sumProperty = (array: any[], property: string) => {
    return array.reduce((a, b) => a + (b[property] || 0), 0);
};